// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WIT1","rootNoMargin":"styles_rootNoMargin__1jKg1"};